if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
  setTimeout(() => {
    const target = document.querySelector('.cart-drawer__dialog');
    if (!target) return;

    const observer = new MutationObserver((mutations) => {
      for (let mutation of mutations) {
        if (mutation.attributeName === "open") {
          const isOpen = target.hasAttribute("open");

          if (isOpen) {
            BSS_B2B.observer.cartSubject.notifyObserver('CartUpdate', 'CartMutate');
          }
        }
      }
    });

    observer.observe(target, {
      attributes: true,
      attributeFilter: ["open"]
    });
  }, 300);
}
